/** @jsxImportSource @emotion/react */
import { Card } from 'react-bootstrap'

import { useLabPermission } from 'hooks/useLabPermission'
import { UserPermission } from 'components/lab/user/permissions'
import config from 'config/app'

import { QuickSightEmbed } from './QuickSightEmbed'

// Every billing dashboard shares the Billing Analytics permission; the KPI
// scorecard passes its own dashboard id.
export const BillingAnalytics = ({ dashboardId = config?.billingAnalyticsDashboardId }: { dashboardId?: string }) => {
  const canView = useLabPermission(UserPermission.VIEW_BILLING_ANALYTICS)

  if (!canView) {
    return (
      <div className="container-fluid">
        <Card className="mt-3 border-0 shadow-sm">
          <Card.Body className="text-center text-muted py-5">
            <i className="fas fa-lock fa-3x mb-3" css={{ opacity: 0.3 }} />
            <p className="mb-0">You do not have access to billing analytics.</p>
          </Card.Body>
        </Card>
      </div>
    )
  }

  // The dashboard id changes when the analysis is repointed from the dev database to the
  // production read replica; until it's set for this environment, show a plain message
  // instead of a crash or a blank iframe.
  if (!dashboardId) {
    return (
      <div className="container-fluid">
        <Card className="mt-3 border-0 shadow-sm">
          <Card.Body className="text-center text-muted py-5">
            <i className="fas fa-chart-pie fa-3x mb-3" css={{ opacity: 0.3 }} />
            <p className="mb-0">Billing analytics is not configured for this environment.</p>
          </Card.Body>
        </Card>
      </div>
    )
  }

  return (
    <div css={{ height: '100vh' }}>
      <QuickSightEmbed dashboardId={dashboardId} />
    </div>
  )
}

export default BillingAnalytics
